import { LayaEnv } from "../../LayaEnv";
import { Component } from "../components/Component";
import { DrawTextureCmd } from "../display/cmd/DrawTextureCmd";
import { Event } from "../events/Event";
import { PAL } from "../platform/PlatformAdapters";
import { Texture } from "../resource/Texture";
export class VideoPlayer extends Component {
    constructor() {
        super();
        this.options = { controls: false, objectFit: "contain" };
        this.mode = "decoder";
        this._autoPlay = false;
        this._loop = false;
        this._volume = 1;
        this._muted = false;
        this._playbackRate = 1;
        this._allowBackground = false;
        this._paused = false;
        this.runInEditor = true;
    }
    get player() {
        return this._api;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        var _a;
        this._source = value;
        if (value) {
            if ((_a = this.owner) === null || _a === void 0 ? void 0 : _a.activeInHierarchy)
                this._load();
        }
        else
            this._unload();
    }
    get autoPlay() {
        return this._autoPlay;
    }
    set autoPlay(value) {
        this._autoPlay = value;
        if (this._api && LayaEnv.isPlaying)
            value ? this._api.play() : this._api.pause();
    }
    get allowBackground() {
        return this._allowBackground;
    }
    set allowBackground(value) {
        this._allowBackground = value;
        if (this._api)
            this._api.allowBackground = value;
    }
    get currentTime() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.currentTime;
    }
    set currentTime(value) {
        if (!this._api)
            return;
        this._api.currentTime = value;
    }
    get readyState() {
        var _a, _b;
        return (_b = (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.readyState) !== null && _b !== void 0 ? _b : 0;
    }
    get videoWidth() {
        var _a;
        return (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.videoWidth;
    }
    get videoHeight() {
        var _a;
        return (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.videoHeight;
    }
    get duration() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.duration;
    }
    get ended() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.ended;
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        this._loop = value;
        if (this._api)
            this._api.loop = value;
    }
    get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(value) {
        this._playbackRate = value;
        if (this._api)
            this._api.playbackRate = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        this._volume = value;
        if (this._api)
            this._api.volume = value;
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        this._muted = value;
        if (this._api)
            this._api.muted = value;
    }
    get paused() {
        return this._paused;
    }
    get videoTexture() {
        return this._vtex;
    }
    play() {
        if (!this._api)
            return;
        this._paused = false;
        this._api.play();
    }
    pause() {
        this._paused = true;
        if (this._api)
            this._api.pause();
    }
    _load() {
        let player;
        let vt;
        let backendType = LayaEnv.isPlaying ? this.mode : "decoder";
        if (backendType === "player") {
            player = (this._player || PAL.media.createVideoPlayer());
            if (!player)
                vt = PAL.media.createVideoTexture();
        }
        else {
            vt = (this._vtex || PAL.media.createVideoTexture());
            if (!vt)
                player = PAL.media.createVideoPlayer();
        }
        if (player) {
            if (this._player !== player) {
                this._player = player;
                this._player.attachTo(this.owner);
                this._player.options = this.options;
            }
            if (this._vtex) {
                this._vtex.destroy();
                this._vtex = null;
                this.owner.graphics.removeCmd(this._textureCmd, true);
                this._textureCmd = null;
            }
        }
        else {
            if (this._vtex !== vt) {
                this._vtex = vt;
                this._vtex.on(Event.READY, this, this._vtReady);
                this._vtex.on("videoUpdate", this.owner, this.owner.reCache);
                if (!this._textureCmd) {
                    this._textureCmd = DrawTextureCmd.create(new Texture(), 0, 0, 1, 1, null, null, null, null, null, true);
                    this._textureCmd.lock = true;
                    this.owner.graphics.addCmd(this._textureCmd);
                }
            }
            if (this._player) {
                this._player.destroy();
                this._player = null;
            }
        }
        this._api = player || vt;
        this._api.loop = this._loop;
        this._api.volume = this._volume;
        this._api.muted = this._muted;
        this._api.playbackRate = this._playbackRate;
        this._api.allowBackground = this._allowBackground;
        if (this._autoPlay && !this._paused && LayaEnv.isPlaying)
            this._api.play();
        else
            this._api.pause();
        this._api.load(this._source);
    }
    _vtReady() {
        var _a;
        this._textureCmd.texture.setTo(this._vtex);
        (_a = this.owner) === null || _a === void 0 ? void 0 : _a.graphics.repaint();
    }
    _unload() {
        var _a;
        if (this._vtex) {
            this._vtex.off(Event.READY, this, this._vtReady);
            this._vtex.off("videoUpdate", this.owner, this.owner.reCache);
            this._vtex.destroy();
            this._vtex = null;
            this.owner.graphics.removeCmd(this._textureCmd, true);
            this._textureCmd = null;
        }
        (_a = this._player) === null || _a === void 0 ? void 0 : _a.destroy();
        this._player = null;
        this._api = null;
    }
    _onEnable() {
        if (!this._api && this._source)
            this._load();
        super._onEnable();
    }
    _onDisable() {
        this._unload();
        super._onDisable();
    }
    _onDestroy() {
        this._unload();
        super._onDestroy();
    }
}
